// TODO ND: We should come up with a better abstraction for this. And it should live somewhere
// more generic like the component-library

export default {
  'data-tag': 'allowRowEvents',
};
